import { Machina } from './machina.js';
/** Get WebSocket events as an async iterator. */
async function* messages(socket, signal) {
    const machina = new Machina();
    socket.addEventListener('message', handleMessage);
    socket.addEventListener('close', handleClose);
    signal.addEventListener('abort', handleClose);
    function handleMessage(ev) {
        machina.push(ev);
    }
    function handleClose() {
        machina.close();
    }
    for await (const msg of machina.stream()) {
        yield msg;
    }
    socket.removeEventListener('message', handleMessage);
    socket.removeEventListener('close', handleClose);
    signal.removeEventListener('abort', handleClose);
}
/** Send a message to a WebSocket, waiting for the socket to open if necessary. */
async function send(socket, data) {
    await waitForOpen(socket);
    socket.send(data);
}
/** Wait for a WebSocket to open. */
async function waitForOpen(socket) {
    switch (socket.readyState) {
        case WebSocket.OPEN:
            return;
        case WebSocket.CONNECTING:
            return await new Promise((resolve, reject) => {
                socket.addEventListener('open', () => resolve(), { once: true });
                socket.addEventListener('close', () => reject(new Error('WebSocket closed before opening.')), { once: true });
            });
        case WebSocket.CLOSING:
        case WebSocket.CLOSED:
            throw new Error('WebSocket is closing or closed.');
    }
}
/** Close the socket, and then wait for it to be closed. */
async function close(socket, code, reason) {
    switch (socket.readyState) {
        case WebSocket.CLOSED:
            return;
        case WebSocket.OPEN:
        case WebSocket.CONNECTING:
        case WebSocket.CLOSING:
            return await new Promise((resolve) => {
                socket.addEventListener('close', () => resolve(), { once: true });
                socket.close(code, reason);
            });
    }
}
/** Functions that make WebSockets more pleasant to use with async code. */
const AsyncSocket = {
    messages,
    send,
    waitForOpen,
    close,
};
export { AsyncSocket };
